
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airports/articles/[id]",
      function () {
        return require("private-next-pages/airports/articles/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airports/articles/[id]"])
      });
    }
  